/* src/app/components/base-component/base-component.component.css */
/*# sourceMappingURL=base-component.component.css.map */
